import { LiveFunctionCall } from '../GeminiLiveAPI/lib/multimodal-live-types'

export const TOOL_NAME = 'stop_voice'

export async function StopVoiceToolCall(functionCall: LiveFunctionCall, history: any, orgId: number | undefined) {
  console.log('[Voice] StopVoiceToolCall - stopping voice session')

  // Update tool execution state to completed for the current message
  if (window.reduxStore) {
    const state = window.reduxStore.getState()
    const messages = state?.chatDrawer?.messages || []
    const lastMessageIndex = messages.length - 1

    if (lastMessageIndex >= 0) {
      const { chatDrawerActions } = await import('ducks/chatDrawer')
      window.reduxStore.dispatch(
        chatDrawerActions.updateToolExecutionState(lastMessageIndex, {
          toolType: 'stopVoice',
          status: 'completed',
          description: 'Voice session stopped',
        })
      )
    }
  }

  // Stop the voice session asynchronously to allow the tool response to be sent first
  Promise.resolve().then(() => {
    if (typeof window !== 'undefined' && (window as any).voiceStopSession) {
      try {
        ;(window as any).voiceStopSession()
      } catch (error) {
        console.error('[Voice] Error calling stopSession:', error)
      }
    }
  })

  return {
    success: true,
    message: 'Voice session stopped successfully',
  }
}
